import { CreateUsersTy, IqueryParams, UserQuery, UserVerifyTy } from "../../config/types";
import { apiService } from "../api.service";
import { GetUser } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";

const createUser = async (form: CreateUsersTy) => {
  return apiService.apiRequest<GetUser>("post", `users`, form);
};

const getUserProfile = async () => {
  return apiService.apiRequest<UserVerifyTy>("get", `users/me`);
};

const getUserStatus = async (email: string) => {
  const query = buildQueryString({ email });
  return apiService.apiRequest<any>("get", `users/status${query}`);
};
const getUserById = async (user_id: string) => {
  return apiService.apiRequest<GetUser>("get", `/users/${user_id}`);
};

const updateUser = async (user_id: string, data: Partial<CreateUsersTy>) => {
  return apiService.apiRequest<GetUser>("put", `/users/${user_id}`, data);
};

const restoreUser = async (user_id: string) => {
  return apiService.apiRequest<undefined>("patch", `users/${user_id}/restore`);
};
const deActiviateUser = async (user_id: string) => {
  return apiService.apiRequest<undefined>(
    "patch",
    `users/${user_id}/deactivate`
  );
};

const changeUserPassword = async (data: {
  current_password: string;
  new_password: string;
}) => {
  return apiService.apiRequest<any>("patch", `users/me/change-password`, data);
};

const listUsers = async (queryParams?:IqueryParams<UserQuery>) => {

  const query = buildQueryString(queryParams);
  return apiService.apiRequest<GetUser[]>("get", `users${query}`);
};

const deleteUser = async (id: string) => {
  return apiService.apiRequest<any>("delete", `users/${id}`);
};
export const UserApi = {
  createUser,
  getUserProfile,
  deleteUser,
  listUsers,
  getUserStatus,
  getUserById,
  updateUser,
  restoreUser,
  deActiviateUser,
  changeUserPassword
};
